export default __webpack_public_path__ + "static/media/fc_icon_terrible.41de0750.svg";